import styled from "styled-components";

export const Page = styled.section`
  --px: ${(p) => p.theme.spacing[4]};

  padding: 7rem var(--px) 4rem var(--px);
`;
